module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "app-footer"
  }, [_c('span', [_vm._v("网易公司版权所有 © 1997-2018")]), _vm._v(" "), _c('span', {
    staticClass: "ml-auto"
  }, [_vm._v("Powered by "), _c('a', {
    attrs: {
      "href": "http://coreui.io"
    }
  }, [_vm._v("CoreUI")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-0554cad5!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = GMHj
// module chunks = 4